<template>
    <svg class="home-indicator" xmlns="http://www.w3.org/2000/svg" width="88" height="88" viewBox="0 0 88 88" @click="$emit( 'click' )">
        <circle cx="44" cy="44" r="44" fill="#fff"/>
        <g>
            <path stroke="null" :fill="color" id="svg_1" d="m63.56505,41.373821l-3.807963,-3.805337l0,-9.32557c0,-1.4444 -1.181782,-2.626181 -2.626181,-2.626181l-2.626181,0c-1.4444,0 -2.626181,1.181782 -2.626181,2.626181l0,1.452278l-5.252363,-5.24711c-0.716947,-0.677555 -1.373493,-1.457531 -2.626181,-1.457531s-1.909234,0.779976 -2.626181,1.457531l-16.938869,16.925738c-0.819369,0.853509 -1.4444,1.475914 -1.4444,2.626181c0,1.47854 1.13451,2.626181 2.626181,2.626181l2.626181,0l0,15.757088c0,1.4444 1.181782,2.626181 2.626181,2.626181l7.878544,0l0,-13.130906c0,-1.4444 1.181782,-2.626181 2.626181,-2.626181l5.252363,0c1.4444,0 2.626181,1.181782 2.626181,2.626181l0,13.130906l7.878544,0c1.4444,0 2.626181,-1.181782 2.626181,-2.626181l0,-15.757088l2.626181,0c1.491671,0 2.626181,-1.147641 2.626181,-2.626181c0,-1.150267 -0.625031,-1.772672 -1.4444,-2.626181z"/>
        </g>
    </svg>
</template>

<script>
    export default {
        props: {
            color: {
                type: String,
                default: '#a5147e'
            }
        }
    };
</script>

<style>

</style>
